export default "__VITE_ASSET__vo9oGqvp__"